const getters = {
	profile: state => state.profile,
	loggedIn: state => !!state.profile,
}

export default getters
